import { MobileBaseField } from '../BaseField/models';

export const MobileOilQualityField = MobileBaseField.extend({
    defaults: {
        id: null,
        acceptance_criteria: {},
        type: 'oil_quality',
        value: null,
        acceptance_value: null,
        follow_up_actions: null,
        reading_method: null
    },

    validation: {
        value: {
            pattern: 'number',
            required: function (val, attr, attrs) {
                return this._is_required(val, attr, attrs);
            }
        }
    }
});
